export default function () {
  const controls = document.querySelectorAll('.c-quantity');

  controls.forEach((control, idx) => {
    const input = control.querySelector('.c-quantity__input');
    const decrement = control.querySelector('.c-quantity__button--decrease');
    const increment = control.querySelector('.c-quantity__button--increase');

    if (input) {
      const newId = `product_quantity_${idx}`;
      input.id = newId;
      const label = control.querySelector('.c-quantity__label');
      if (label) label.setAttribute('for', newId);
    }

    const min = Number.isFinite(parseInt(input.getAttribute('min'), 10))
      ? parseInt(input.getAttribute('min'), 10) : 1;
    const maxAttr = input.getAttribute('max');
    const max = maxAttr ? parseInt(maxAttr, 10) : Infinity;

    const clamp = (v) => Math.max(min, Math.min(max, v));

    decrement.addEventListener('click', () => {
      let value = parseInt(input.value, 10);
      if (Number.isNaN(value)) value = min;
      input.value = clamp(value - 1);
      // Trigger change event for WooCommerce cart updates
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    increment.addEventListener('click', () => {
      let value = parseInt(input.value, 10);
      if (Number.isNaN(value)) value = min;
      input.value = clamp(value + 1);
      // Trigger change event for WooCommerce cart updates
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
}
